<template>
  <div class="login max-h-screen" style="height: 96vh">
    <div class="hidden md:block">
      <img src="@/assets/images/v2/Grupo 23.png" style="width: 180px" alt="" class="mx-auto mb-16 mt-10">
    </div>
    <router-link to='/' class=" block md:hidden">
        <img src="@/assets/images/v2/Icon awesome-arrow-left.png" alt="" class="p-4 mb-8">
    </router-link>
    <div class="container mb-16">
      <div class="row flex mb-4 justify-items-center">
          <div class="col-md-6 offset-md-3 text-center">
            <img src="@/assets/images/v2/OpcioA_400x400.png" alt="" class="inline-block w-28 -mt-8 mr-4">
            <img src="@/assets/images/v2/OpcioB_400x400.png" alt="" class="inline-block w-28 -mt-8">
          </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
            <h5 class="fw-bold lh-base my-4 text-3xl md:text-xl uppercase">Benvingut/da a la consulta per a la renovació de l'escut del Girona FC</h5>
            <p>
              Per a participar a la consulta, identifica't amb les teves credencials de Soci.
            </p>
        </div>
        <div class="col-md-3 mx-auto">
          <div v-if="error != ''" class="alert alert-danger">
            {{ error }}
          </div>
          <form>
            <div class="form-group mb-3 mt-12">
              <input type="text" placeholder="ID" v-model="id" class="border-r-0 border-b-2 border-black">
            </div>
            <div class="form-group">
              <input type="text" placeholder="PIN" v-model="pin" class="border-r-0 border-bottom-1">
            </div>
            <div class="mt-16 text-center">
                <button @click="login()" class="mb-3 py-2" type="button" style="background-color: #cd1733; border-radius: 10px; border: 2px solid #cd1733; color: #fff; text-transform: uppercase; font-weight: bold; text-decoration: none; padding: 4px 62px;">Accedeix</button><br>
                  <a class="text-blue-600 underline font-bold" style="display: inline; line-height: 18px; font-size: 15px; margin-bottom: 8px;" href="https://online.gironafc.cat/index.php/ca-es/recuperar-pin" target="_blank">Consulta el teu pin</a>
                <p>
                  Encara no ets soci?
                  <a href="https://online.gironafc.cat/index.php/ca-es/altas-socis" class="py-2" target="_blank" style="">Fes-te soci</a>
                </p>
            </div>
          </form>
        </div>
      </div>
    </div>
     <div class="partners bg-girona relative w-full md:mt-0 mt-16">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8'

export default {
  head() {
    return {
      title: 'Login - Girona FC',
      meta: [
        { hid: 'description', name: 'description', content: 'Consulta per a la renovació de l\'escut del Girona FC' },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ]
    }
  },
  data() {
    return {
      id: "",
      pin: "",
      error: "",
    }
  },
  methods: {
    login() {
      if(this.pin == "" || this.id == "") return false
      let instance = this

      let loader = this.$loading.show();

      let hash = this.id + "_" + CryptoJS.MD5(this.pin)
      let extra = Base64.stringify(CryptoJS.enc.Utf8.parse(this.pin))

      this.$http.get("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=club_auth_girona&hash=" + hash + "&extra=" + extra + "&club=girona&type=1").then((response) => {
        if(response.data.response.result == 'error') {
          instance.error = response.data.response.message
        } else if(response.data.user) {
          this.$cookies.set('member_number', response.data.user.member_number);
          this.$cookies.set('username', response.data.user.profile.name);

          window.username = response.data.user.profile.name
          this.$router.push('/consulta-v2')
        }

        loader.hide()

      })
    }
  },
  mounted() {
    // let member_number = this.$cookies.get("member_number");

    // if(member_number != null) {
    //   this.$router.push('/consulta-v2')
    // }

    this.$router.push('/consulta-v2')
  }
}
</script>

